var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemperance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 427.36 406.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke-width: 4px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #fff200;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 25.57,
    y1: 214.8,
    x2: 401.79,
    y2: 214.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 295.27,
    y1: 288.55,
    x2: 212.5,
    y2: 378.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133.68,
    y1: 288.55,
    x2: 212.5,
    y2: 378.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 295.27,
    y1: 118.37,
    x2: 212.5,
    y2: 28.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133.68,
    y1: 118.37,
    x2: 212.5,
    y2: 28.77
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "401.79 237.49 395.66 220.93 379.1 214.8 395.66 208.67 401.79 192.12 407.91 208.67 424.47 214.8 407.91 220.93 401.79 237.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "25.57 237.49 19.44 220.93 2.88 214.8 19.44 208.67 25.57 192.12 31.7 208.67 48.26 214.8 31.7 220.93 25.57 237.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "133.68 311.23 127.55 294.68 110.99 288.55 127.55 282.42 133.68 265.86 139.81 282.42 156.36 288.55 139.81 294.68 133.68 311.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "295.27 311.23 289.14 294.68 272.58 288.55 289.14 282.42 295.27 265.86 301.39 282.42 317.95 288.55 301.39 294.68 295.27 311.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "213.72 403.69 207.14 386.31 188.59 387.19 203.08 375.57 196.51 358.19 212.04 368.39 226.54 356.77 221.64 374.69 237.17 384.88 218.61 385.76 213.72 403.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "133.68 95.68 127.55 112.24 110.99 118.37 127.55 124.5 133.68 141.06 139.81 124.5 156.36 118.37 139.81 112.24 133.68 95.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "295.27 95.68 289.14 112.24 272.58 118.37 289.14 124.5 295.27 141.06 301.39 124.5 317.95 118.37 301.39 112.24 295.27 95.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "213.72 3.23 207.14 20.61 188.59 19.73 203.08 31.35 196.51 48.73 212.04 38.53 226.54 50.15 221.64 32.23 237.17 22.03 218.61 21.15 213.72 3.23"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperance);
export default __webpack_public_path__ + "static/media/Temperance.713744eca84451405572861510f3486e.svg";
export { ForwardRef as ReactComponent };